import { API_S2S_INTEGRATION, API_S2S_OPPORTUNITIES, API_S2S_PROPOSALS } from "globals/constants";
import { put, spUrl, remove } from "utils";
import { buildSearchParams, request, save } from "utils/proxy";

export const s2s = {
    /**
     * Retrieve a list of S2S Opportunities.
     *
     * @param {object} params - Query parameters for filtering and pagination.
     * @param {string} url - Full S2S instance url.
     * @param {{}?} options - Request options.
     * @param {number} [params.page] - The page number for pagination.
     * @param {number} [params.size] - The number of items per page.
     * @param {string[]} [params.search] - A search term for filtering.
     *
     * @returns {Promise<{}[]>} A Promise that resolves with the list of S2S Opportunities.
     */
    findAll: (params, url, options) =>
        request(
            `${url}${API_S2S_OPPORTUNITIES}${buildSearchParams(params)}`,
            options
        ),

    /**
     * Create S2S Proposal.
     *
     * @param {string} url - Full S2S instance url.
     * @param {{}?} options - Request options.
	 * @param {{}} body - Request body.
     *
     * @returns {Promise<{}[]>} A Promise that resolves with the list of S2S Opportunities.
     */
    createProposal: (body, url, options) =>
        save(
            `${url}${API_S2S_PROPOSALS}`,
			body,
            options
        ),

    /**
     * @param {string} proposalId
     * @param {{}} body
     * @param {{}?} options
     */
    get: (proposalId, options) =>
        request(spUrl(`${API_S2S_INTEGRATION}/${proposalId}`), {}, options),

    /**
     * @param {{proposalId: string, s2sProposalId: string}} params
     * @param {{}} body
     * @param {{}?} options
     * @returns {Promise<{}>}
     */
    createLink: (params, body, options) =>
        put(
            spUrl(
                `${API_S2S_INTEGRATION}/${params.proposalId}/${params.s2sProposalId}`
            ),
            body,
            options
        ),

    /**
     * @param {string} proposalId
     * @param {{}} body
     * @param {{}?} options
     */
    unlink: (proposalId, options) =>
        remove(spUrl(`${API_S2S_INTEGRATION}/${proposalId}`), {}, options),

    /**
     * @param {string} proposalId
     * @param {{}} body
     * @param {{}?} options
     * @returns {Promise<{}>}
     */
    createReferenceId: (proposalId, body, options) =>
        save(spUrl(`${API_S2S_INTEGRATION}/${proposalId}`), body, options),
};
